<template>
  <EarningsBody/>
</template>

<script>
// @ is an alias to /src
import EarningsBody from '@/components/EarningsBody.vue'

export default {
  name: 'EarningsView',
  components: {
    EarningsBody
  }
}
</script>
